export const WORK_AT_MANFRED_KEY = 'isInterestedOnWorkAtManfred';
